import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 16px;
  overflow: auto;
`;
